import type { PropsWithChildren } from "react";

import { DatasetCard } from "@/modules/dataset/dataset-card";
import DatasetZoom from "@/modules/dataset/dataset-zoom";

import DatasetPlanPositioningEditor from "../dataset-plan-positioning-editor";
import { useDatasetPlanPositioningContext } from "../dataset-plan-positioning.context";

const DatasetPlanPositioningCard = ({ children }: PropsWithChildren) => {
  const { template, dataset, loading, disabled } =
    useDatasetPlanPositioningContext();

  return (
    <DatasetCard
      datasetType="planPositioning"
      template={template}
      dataset={dataset}
      loading={loading}
      disabled={disabled}
      actionsPlacement="beforeContent"
      beforeActions={
        <DatasetZoom
          datasetType="planPositioning"
          template={template}
          dataset={dataset}
          loading={loading}
          disabled={disabled}
        >
          <DatasetPlanPositioningEditor
            toolbarOptions={{ showZoom: true }}
            fitToWrapper
          />
        </DatasetZoom>
      }
    >
      {children}
    </DatasetCard>
  );
};

export default DatasetPlanPositioningCard;
